var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4999 7.1375V19.1125C27.4999 22.5625 24.6999 25.3625 21.2499 25.3625H8.7499C8.1749 25.3625 7.62491 25.2875 7.08741 25.1375C6.31241 24.925 6.0624 23.9375 6.6374 23.3625L19.9249 10.075C20.1999 9.8 20.6124 9.73749 20.9999 9.81249C21.3999 9.88749 21.8374 9.77499 22.1499 9.47499L25.3624 6.25C26.5374 5.075 27.4999 5.4625 27.4999 7.1375Z",
    fill: "#4B5563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 9.20002L5.2125 22.2875C4.6125 22.8875 3.6125 22.7375 3.2125 21.9875C2.75 21.1375 2.5 20.15 2.5 19.1125V7.13752C2.5 5.46252 3.4625 5.07502 4.6375 6.25002L7.8625 9.48752C8.35 9.96252 9.15 9.96252 9.6375 9.48752L14.1125 5.00002C14.6 4.51252 15.4 4.51252 15.8875 5.00002L18.3125 7.42502C18.7875 7.91252 18.7875 8.71252 18.3 9.20002Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/standard.767aa8d983941040f04e772f6b2713ee.svg";
export { ForwardRef as ReactComponent };